export function extractRiverParam(match) {
  const { river } = match.params || {};
  return decodeURIComponent(river || '');
}
